/* eslint-disable */

import SignUpTemplate from "./template";

const Reseller = () => {
  return (
    <div>
      <SignUpTemplate userPackage={"reseller"} />
    </div>
  );
};

export default Reseller;
